// 3-5 Educators PD Conference data — same structure, colors, links, sponsors as the source app
// audience: 3-5 educators

export const CONFERENCE = {
  title: "BCS District PD Conference",
  tagline: "Nurture. Guide. Empower.",
  subTagline: "AI in Teaching & Learning",
  audience: "3-5 educators",
  audienceSegment: "primary",
  date: "June 8, 2026",
  year: 2026,
  registrationNumber: "344915",
  registrationDeadline: "May 31, 2026",
  ceus: 12,
  schoologyAccessCode: "QM79-25D5-J63TQ",
  welcome:
    "Welcome, 3-5 educators! Today we explore how AI can support, inspire, and elevate elementary teaching.",
};

// Hero background image
export const HERO_BG_URL =
  "https://images.unsplash.com/photo-1755538497211-c4ebc7cc1a94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMHRlY2hub2xvZ3klMjBlZHVjYXRpb24lMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3NzIzNTU2MHww&ixlib=rb-4.1.0&q=85";

// Local logo paths
export const BCS_LOGO = "/bcs-logo.png";

// Lunch sponsor — District Management Group
export const LUNCH_SPONSORS = [
  {
    name: "District Management Group",
    logo: "/dmg-logo.png",
    url: "https://www.dmgroup.com/",
  },
];

// Announcements shown on the Home page
export const ANNOUNCEMENTS = [
  {
    id: "check-in",
    title: "Check-in opens at 7:30 AM",
    body: "Come early to Carver High School and enjoy a morning of line dancing, scrolling, and exercise. The first 100 to arrive between 7:30 am and 8:00 am will be entered into a drawing for a cash prize.",
  },
  {
    id: "device",
    title: "Bring your charged device",
    body: "All sessions are hands-on with AI tools — an iPad, tablet or laptop is needed if you have one.",
  },
  {
    id: "ceus",
    title: "Earn 12 CEUs for the Nurture. Guide. Empower. Conference",
    body: "To earn 12 CEUs, register via PowerSchool PD (344825) and complete all assignments (Pre Lessons, Sessions, Post Lessons) in Schoology. To enroll in the Schoology course, use the access code VCJC-H4PV-NM7SZ to enroll.",
  },
  {
    id: "book",
    title: "Do not forget to access your book",
    body: "Expand your learning by reading Artificial Intelligence in Education. A copy of this book has been loaded in Schoology under Post Lessons. You will need to read the book to complete your Post Lessons.",
  },
  {
    id: "help",
    title: "Need assistance during the conference",
    body: "Find a person in an orange vest.",
  },
];

// Agenda items
export const AGENDA = [
  {
    id: "morning",
    time: "7:30 - 8:30 AM",
    title: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment",
    description: "All groups attend. Kick off the day, get moving, and find your group!\n\nClick on My Group to determine your assigned group.",
    location: "Auditorium",
    type: "general",
  },
  {
    id: "keynote",
    time: "8:30 - 9:15 AM",
    title: "Keynote: Kai Frazier, CEO Kai XR",
    description: "Welcome and opening keynote address.",
    location: "Auditorium",
    type: "keynote",
  },
  {
    id: "s1",
    time: "9:30 - 10:30 AM",
    title: "Session 1",
    description: "First session — see Group Rotation for your assigned room.",
    location: "Various",
    type: "rotation",
  },
  {
    id: "s2",
    time: "10:45 - 11:45 AM",
    title: "Session 2",
    description: "Second session — see Group Rotation for your assigned room.",
    location: "Various",
    type: "rotation",
  },
  {
    id: "lunch",
    time: "11:45 AM - 1:00 PM",
    title: "Lunch",
    description: "All groups break for lunch together.",
    location: "Cafeteria",
    type: "break",
  },
  {
    id: "s3",
    time: "1:15 - 2:15 PM",
    title: "Session 3",
    description: "Third session — see Group Rotation for your assigned room.",
    location: "Various",
    type: "rotation",
  },
];

// 3 sessions
export const SESSIONS = [
  {
    id: "ai-early-elementary",
    title: "Magma Math",
    location: "Rooms 414, 415, 416, or 417",
    description: "Teachers will explore Magma Math as a tool to strengthen mathematical discourse, formative assessment, and real-time feedback in elementary classrooms. The session will focus on using student work analysis and collaborative problem-solving to support conceptual understanding and standards mastery.",
    icon: "sparkles",
  },
  {
    id: "ai-prompting",
    title: "MagicSchool AI",
    location: "Computer Labs 216, 406, 312, or 408",
    description:
      "This interactive session provides educators with hands-on experience using MagicSchool AI to support daily classroom instruction and streamline teacher workflows. Participants will explore a variety of educator-focused AI tools designed to assist with lesson planning, instructional differentiation, assessment creation, rubric development, parent communication, and classroom engagement. Teachers will learn practical strategies for using AI to save time while maintaining high-quality, student-centered instruction.\n\nThroughout the workshop, participants will have the opportunity to practice using MagicSchool AI tools in real classroom scenarios and create resources they can immediately implement in their classrooms. The session will also highlight responsible AI use, best practices for reviewing AI-generated content, and ways to align AI-supported instruction with district expectations and curriculum goals. By the end of the session, teachers will leave with practical tools and strategies to increase efficiency, personalize learning, and support student success.",
    icon: "wand",
  },
  {
    id: "schoology-gems",
    title: "Social Studies Curriculum Overview",
    location: "Rooms 314, 315, 316, or 317",
    description:
      "3-5 teachers will explore the Cengage social studies curriculum with a focus on standards alignment, lesson design, and instructional pacing. Participants will examine strategies that support literacy, inquiry, and student engagement in history, civics, geography, and economics.",
    icon: "shield",
  },
];

// 3 GROUPS — same colors and structure as source
export const GROUPS = [
  {
    id: "learning_architects",
    name: "Learning Architects",
    bandLabel: "3rd Grade",
    color: "#2F855A",
    accent: "#FFFFFF",
    icon: "construct",
  },
  {
    id: "digital_designers",
    name: "Digital Designers",
    bandLabel: "4th Grade",
    color: "#C53030",
    accent: "#FFFFFF",
    icon: "palette",
  },
  {
    id: "integration_engineers",
    name: "Integration Engineers",
    bandLabel: "5th Grade",
    color: "#F6B829",
    accent: "#FFFFFF",
    icon: "network",
  },
];

// Per-group rotation through ALL three sessions
export const ROTATIONS = {
  learning_architects: [
    { time: "7:30 - 8:30 AM", session: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment", location: "Auditorium" },
    { time: "8:30 - 9:15 AM", session: "Keynote: Kai Frazier, CEO Kai XR", location: "Auditorium" },
    { time: "9:30 - 10:30 AM", session: "Social Studies Curriculum Overview", location: "Rooms 314, 315, 316, or 317" },
    { time: "10:45 - 11:45 AM", session: "Magma Math", location: "Rooms 414, 415, 416, or 417" },
    { time: "11:45 AM - 1:00 PM", session: "Lunch", location: "Lunchroom" },
    { time: "1:15 - 2:15 PM", session: "MagicSchool AI", location: "Computer Labs 216, 406, 312, or 408" },
  ],
  digital_designers: [
    { time: "7:30 - 8:30 AM", session: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment", location: "Auditorium" },
    { time: "8:30 - 9:15 AM", session: "Keynote: Kai Frazier, CEO Kai XR", location: "Auditorium" },
    { time: "9:30 - 10:30 AM", session: "Magma Math", location: "Rooms 414, 415, 416, or 417" },
    { time: "10:45 - 11:45 AM", session: "MagicSchool AI", location: "Computer Labs 216, 406, 312, or 408" },
    { time: "11:45 AM - 1:00 PM", session: "Lunch", location: "Lunchroom" },
    { time: "1:15 - 2:15 PM", session: "Social Studies Curriculum Overview", location: "Rooms 314, 315, 316, or 317" },
  ],
  integration_engineers: [
    { time: "7:30 - 8:30 AM", session: "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment", location: "Auditorium" },
    { time: "8:30 - 9:15 AM", session: "Keynote: Kai Frazier, CEO Kai XR", location: "Auditorium" },
    { time: "9:30 - 10:30 AM", session: "MagicSchool AI", location: "Computer Labs 216, 406, 312, or 408" },
    { time: "10:45 - 11:45 AM", session: "Social Studies Curriculum Overview", location: "Rooms 314, 315, 316, or 317" },
    { time: "11:45 AM - 1:00 PM", session: "Lunch", location: "Lunchroom" },
    { time: "1:15 - 2:15 PM", session: "Magma Math", location: "Rooms 414, 415, 416, or 417" },
  ],
};

export const KEYNOTE = {
  name: "Kai Frazier",
  title: "CEO, Kai XR",
  image:
    "https://customer-assets.emergentagent.com/job_deploy-base44/artifacts/1iktafnc_image.png",
  bio: "Bio coming soon.",
};

export const RESOURCES = [
  { label: "Nurture.Guide.Empower. Conference Website", url: "https://bcsit.org/" },
  { label: "PowerSchool PD", url: "https://bhm.schoology.com/" },
  { label: "Schoology", url: "https://alsde.truenorthlogic.com/ia/empari/login/index" },
];

export const AI_GAMES = [
  {
    title: "AI or Human",
    description:
      "AI-generated media content has come to stay, looking more human than ever. Play the game and try to guess the difference between what is AI or Human.",
    url: "https://ai-or-human.github.io/",
  },
  {
    title: "Most Likely Machine",
    description:
      "Most Likely Machine is an interactive learning experience that helps students understand how algorithms work and how bias can influence automated decisions. Through a playful, school-themed activity, students build and test algorithms, then reflect on how personal assumptions, data choices, and weighting decisions can affect outcomes. This is a strong classroom resource for teaching AI literacy, digital citizenship, fairness, and responsible technology use in a way that is engaging and age-appropriate.",
    url: "https://mostlikelymachine.artefactgroup.com/",
  },
  {
    title: "Quick Draw",
    description:
      "Quick, Draw! is an interactive Google AI experiment where users quickly sketch objects while a neural network attempts to guess the drawings in real time, helping demonstrate how machine learning works through fun, hands-on gameplay.",
    url: "https://quickdraw.withgoogle.com/",
  },
  {
    title: "Say What You See",
    description:
      "Say What You See is an interactive Google Arts & Culture AI experiment that helps users strengthen image-reading and AI prompting skills by carefully describing AI-generated images to recreate them as accurately as possible. The activity encourages critical thinking, observation, descriptive writing, and the creation of strategic prompts while providing a fun and engaging way for students and educators to learn how AI interprets language and visuals.",
    url: "https://artsandculture.google.com/experiment/say-what-you-see/jwG3m7wQShZngw?hl=en",
  },
  {
    title: "Semantris",
    description:
      "Semantris is a Google AI word-association game that uses machine learning to understand the meaning behind words and phrases, helping students explore vocabulary, semantic relationships, critical thinking, and how AI interprets language in a fun, fast-paced way.",
    url: "https://research.google.com/semantris",
  },
  {
    title: "Test Yourself: Which image is made by AI?",
    description:
      "Test Yourself is an interactive image-recognition game where users test their ability to identify which image was generated by artificial intelligence across multiple rounds. This activity is a strong classroom tool for building AI literacy, visual analysis, critical thinking, and discussion about how realistic AI-generated content can appear.",
    url: "https://game.agcs.works/",
  },
  {
    title: "Twin Pics",
    description:
      "Twin Pics is a daily AI image challenge where players use prompts to recreate a mystery image as closely as possible, earning higher scores based on accuracy. Because a new challenge is released each day, participants are encouraged to return daily to strengthen their AI prompting skills while learning how concise writing, detailed descriptions, and strategic word choice impact AI-generated results. It also serves as a fun classroom icebreaker that encourages creativity, collaboration, critical thinking, and discussion around how AI interprets language and prompts.",
    url: "https://twinpics.ai/",
  },
  {
    title: "Two Truths & AI",
    description:
      "An interactive digital literacy activity from Common Sense Media that challenges students to identify AI-generated content while building critical thinking and media literacy skills.",
    url: "https://www.commonsense.org/two-truths-and-ai",
  },
];
